const newseLatterData1 = [
	{
		id: '1',
		icon: { parentBg: '#beaaf7', childBg: 'rgb(131 88 255) ', svg: 'icon-wallet' },

		title: [' Set', ' up', ' your', ' wallet'],
		text: "To begin, connect your wallet to the NFT marketplace by clicking connect wallet on the top right corner.",
	},
	{
		id: '2',
		icon: { parentBg: '#c4f2e3', childBg: 'rgb(16 185 129)', svg: 'icon-wallet' },
		title: [' List', ' your', ' NFTs', ' in', ' marketplace', ' to', ' get', ' loan', ' offers'],
		text: 'You must list the NFTs by specifying the loan terms. Other users will offer you a loan for your NFT.',
	},
	{
		id: '3',
		icon: { parentBg: '#cddffb', childBg: 'rgb(66 138 248)', svg: 'icon-gallery' },
		title: [' Accept', ' The', ' Best', ' Loan', ' Offer', ' For', ' Your', ' NFT'],
		text: 'When you accept the loan offer that suits you best, your NFT enters into a secure smart escrow contract and the loan amount is transferred directly from the lender to your wallet',
	},
	{
		id: '4',
		icon: { parentBg: '#ffd0d0', childBg: 'rgb(239 68 68)', svg: 'icon-list' },
		title: [' Repay', ' The', ' Loan', ' To', ' Get', ' Your', ' NFT', 'Back'],
		text: 'When you pay your loan in full and on time in accordance with its terms, your NFT is automatically returned to your wallet.',
	},
];

export { newseLatterData1 };
